import "./style.css";

import { DailyPuzzleApp } from "./app.ts";
import { competitionApi } from "./competition-api.ts";
import { loadAssetManifests } from "./glyphs.ts";
import { setupInstall } from "./install.ts";
import { decodeTransfer, importTransfer, shouldCollectTransfer, transferUrl } from "./transfer.ts";

const root = document.querySelector<HTMLDivElement>("#app");
if (!root) throw new Error("The application root is missing.");

setupInstall();

// History handoff from the old address (see transfer.ts). Runs before the app reads storage.
async function settleTransfer(): Promise<string> {
  const arriving = location.hash.match(/^#transfer=(.+)$/);
  if (arriving) {
    history.replaceState(null, "", `${location.pathname}${location.search}`);
    const payload = await decodeTransfer(arriving[1]!);
    if (!payload) return "";
    const result = importTransfer(localStorage, payload);
    if (result.code) {
      try { await competitionApi.transferClaim(result.code); } catch { /* the local history still arrives */ }
    }
    return result.days > 0 || result.name
      ? `Welcome to codelet.uk. ${result.days > 0 ? `${result.days} saved ${result.days === 1 ? "day" : "days"}` : "Your name"}${result.days > 0 && result.name ? " and your name" : ""} came across from code.bzwrd.co.uk.`
      : "";
  }
  if (shouldCollectTransfer(localStorage, location.hostname)) {
    location.replace(transferUrl(`${location.pathname}${location.search}`));
    await new Promise(() => undefined);
  }
  return "";
}

try {
  const notice = await settleTransfer();
  const manifests = await loadAssetManifests();
  new DailyPuzzleApp(root, manifests).start(notice);
} catch (error) {
  const message = error instanceof Error ? error.message : "The puzzle could not be opened.";
  root.innerHTML = `
    <main class="fatal-error">
      <h1>Codelet</h1>
      <p>${message}</p>
      <button type="button" data-reload>Try again</button>
    </main>`;
  root.querySelector<HTMLButtonElement>("[data-reload]")?.addEventListener("click", () => {
    window.location.reload();
  });
}